import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Text } from '@dossierhq/design';
import { MapContainer } from '@dossierhq/leaflet';
export function EntityDraftMapMarker({ draftState, location, onClick }) {
    if (!draftState.draft)
        return null;
    return (_jsx(MapContainer.Marker, { location: location, tooltip: _jsxs(Column, { children: [_jsx(Text, { textStyle: "subtitle1", children: draftState.draft.name }), _jsx(Text, { textStyle: "body1", children: draftState.draft.entitySpec.name })] }), onClick: onClick }));
}
//# sourceMappingURL=EntityDraftMapMarker.js.map